import { infractionArray, infractionInit } from 'types/infraction.type'
import { z } from 'zod'
import { ERROR_MESSAGE } from './error.type'

export const hearingNarrativesScheme = z.object({
  narrativaAdolescente: z
    .string({
      required_error: ERROR_MESSAGE,
    })
    .min(1, ERROR_MESSAGE)
    .transform((field) => {
      return field.trim()
    }),
  narrativaRepLegal: z
    .string({
      required_error: ERROR_MESSAGE,
    })
    .min(1, ERROR_MESSAGE)
    .transform((field) => {
      return field.trim()
    }),
  atoInfracionais: infractionArray,
})

export type HearingNarrativesType = z.infer<typeof hearingNarrativesScheme>

export const hearingNarrativesInit: HearingNarrativesType = {
  narrativaAdolescente: '',
  narrativaRepLegal: '',
  atoInfracionais: [infractionInit],
}
